// extracted by mini-css-extract-plugin
export default {"main":"_912279a38c ab27dbbb27","xmark":"_965639dd3a","fl_img":"c0fffb024c f51d207622"};